import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";

import React, { useEffect, useState } from "react";
import { ISearchPage } from "../../../types/FmsTypes";
import { transPgToPagination } from "../app/appModel";
import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
    defaultMdCmParam
} from "../../../utils/constants";
import {
    customerService,
    IMdCustomerDetail, IMdCustomerFields,
} from "./customerService";
import { message } from "antd";
import useGlobalModel from "@/model/globalModel";

export const useCustomerModel = createModel(function () {
    // const { customerLoadDataAll } = useGlobalModel(() => []);
    const initSearchParam: IMdCustomerFields = {};
    const initDataSource: IMdCustomerDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }

    //查询条件
    const [searchParam, setSearchParam] = useState<IMdCustomerFields>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IMdCustomerDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [selectedData, setSelectedData] = useState<IMdCustomerFields>();
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [drawerVisible, setDrawerVisible] = useState(false);

    const [synchroModel, setSynchroModel] = useState<boolean>(false)
    const [syncLoading, setSyncLoading] = useState<boolean>(false);


    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }

    const updateSearchParam = (updateParam: IMdCustomerFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }

    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
        setSelectedData(undefined)
    }

    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IMdCustomerFields = searchParam) => {
        const searchParams = {
            ...defaultMdCmParam,
            ...searchValue,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await customerService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        clearSelectData();
    }
    const syncData = async (params?: object) => {
        let ret = await customerService.sync({...searchParam,...params});
        ret ? message.success("同步成功!重新加载数据...") : message.error("同步失败");
        ret && await loadData(initPgCfg, {});
        // ret && await customerLoadDataAll();
        return ret.retData;
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        selectedData,
        synchroModel,
        syncLoading,
        initPgCfg,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
        syncData,
        setSelectedData,
        setSynchroModel,
        setSyncLoading
    }
});